
export default [
	'nl',
	'en',
	'fr'
] as Array<String>;
